import React from 'react';

import ContextContentMixin from './../context_content_mixin';
import CustomStylesMixin from './../custom_styles_mixin';
import RevealMixin from '../reveal_mixin';

import createReactClass from 'create-react-class';
export default createReactClass({
  mixins: [ContextContentMixin, CustomStylesMixin, RevealMixin],

  displayName: 'Maintenance',

  render: function() {
    return (
      <div className="content-container">
        <div className="head-line" style={this.secondary_text_color()}>
          Maintenance
        </div>
        <div className="subheader" style={this.primary_text_color()}>
          We're undergoing a bit of scheduled maintenance.
        </div>
        <hr style={this.hrBackgroundColor()} />
        <div className="clearfix"></div>
        <div className="context" style={this.primary_text_color()}>
          {this.contextContent()}
        </div>
        <div className="buttons-container">
          <a
            href={this.href(this.props.status_page_url)}
            style={this.mergeStyles(
              this.has_status_page(),
              this.borderButton(),
            )}
            target="_blank"
          >
            View Statuspage
          </a>
        </div>
      </div>
    );
  },
});
